import { render } from "./DeckBuilderComponent.vue?vue&type=template&id=467f73c8"
import script from "./DeckBuilderComponent.vue?vue&type=script&lang=js"
export * from "./DeckBuilderComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__